import { render, staticRenderFns } from "./Origin-Split.vue?vue&type=template&id=130611c7&scoped=true"
import script from "./Origin-Split.vue?vue&type=script&lang=js"
export * from "./Origin-Split.vue?vue&type=script&lang=js"
import style0 from "./Origin-Split.vue?vue&type=style&index=0&id=130611c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130611c7",
  null
  
)

export default component.exports